import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService, HttpOptions } from '@ipg/ngx-frontend-toolset';
import {
  UserRole,
  UserRoleCreateRequest,
  UserRoleUpdateRequest,
} from '../models/user-role.model';

@Injectable({ providedIn: 'root' })
export class UserRoleService {
  private readonly _backend = inject(BackendService);

  getList(options?: HttpOptions): Observable<UserRole[]> {
    return this._backend.get('/user-roles', options);
  }

  getById(id: string): Observable<UserRole> {
    return this._backend.get(`/user-roles/${id}`);
  }

  create(data: UserRoleCreateRequest): Observable<UserRole> {
    return this._backend.post('/user-roles', data);
  }

  update(id: string, data: UserRoleUpdateRequest): Observable<UserRole> {
    return this._backend.put(`/user-roles/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this._backend.delete(`/user-roles/${id}`);
  }
}
